import React from "react";

const ListItemWidget = (props) => {
  const { title, text } = props;
  return (
    <div className="border-bottom">
      <small className="text-primary">{title}</small>
      <p className="word-break">{text}</p>
    </div>
  );
};

export default ListItemWidget;
